import url from 'configs/url';

export default {
  NewTube: {
    rootUrl: '/tube',
    text: 'LinkUp',
    authName: 'Tube',
    activePathRegExp: /^\/tube/i,
    excludePathRegExp: null,
    target: '_self',
    sort: 1,
  },
  TA: {
    rootUrl: '/ta',
    text: 'Attendance',
    authName: 'Ta',
    activePathRegExp: /^\/ta/i,
    excludePathRegExp: null,
    target: '_self',
    sort: 2,

  },
  Foundation: {
    rootUrl: '/Foundation',
    text: 'Foundation',
    authName: 'Foundation',
    activePathRegExp: /^\/foundation/i,
    excludePathRegExp: null,
    target: '_self',
    sort: 3,
  },
  PY: {
    rootUrl: '/payroll',
    text: 'Payroll',
    authName: 'Pr',
    activePathRegExp: /^\/payroll/i,
    excludePathRegExp: null,
    target: '_self',
    sort: 4,
  },
  RMS: {
    rootUrl: '/rms',
    text: 'Recruitment',
    authName: 'Rms',
    activePathRegExp: /^\/rms/i,
    excludePathRegExp: null,
    target: '_self',
    sort: 5,
  },
  // 新招募站台，與舊的 RMS 互斥：只有「沒有 RMS 模組」且 permission 含 jobhub 的人才看得到，
  // 顯示條件不看 userInfo 的 userModule（後端不會回 JobHub），改由 requirePermission 比對 permissions API。
  JobHub: {
    rootUrl: url.JOBHUB,
    text: 'Recruitment',
    authName: 'Jobhub',
    activePathRegExp: /^\/jobhub/i,
    excludePathRegExp: null,
    target: '_blank',
    sort: 5,
    // 比對是大小寫敏感的字面比對，必須與 permissions API 實際回傳的 'jobhub' 完全一致
    requirePermission: 'jobhub',
    isBeta: true,
    syncLocale: true,
  },
  Dashboard: {
    rootUrl: '/dashboard',
    text: 'Dashboard',
    authName: 'Dashboard',
    activePathRegExp: /^\/dashboard/i,
    excludePathRegExp: null,
    target: '_self',
    sort: 6,
  },
  MAYOForm: {
    rootUrl: `${url.NEW_XE}/mayo-form/apply/list`,
    text: 'MAYO Form',
    authName: 'MAYOForm',
    activePathRegExp: /^\/mayo-form/i,
    excludePathRegExp: null,
    target: '_blank',
    sort: 7,
    syncLocale: true,
  },
};



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/configs/modules.js
 **/